import { render } from "./media-msg-box.vue?vue&type=template&id=4a9bf92f&scoped=true&ts=true"
import script from "./media-msg-box.vue?vue&type=script&lang=ts"
export * from "./media-msg-box.vue?vue&type=script&lang=ts"

import "./media-msg-box.vue?vue&type=style&index=0&id=4a9bf92f&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9bf92f"]])

export default __exports__